import React, { useEffect, useState } from "react";
import { Card, Form, Select, InputNumber, Input, Button, message, Table, Tag, Space } from "antd";
import { InboxOutlined } from "@ant-design/icons";
import { scWarehouseReceipt, scGetParties, scGetEvents } from "../../api/client";
import { JalaliDateInput, todayISO, toJalali } from "../../utils/dateUtils";
import { byDate } from "../../utils/sorters";
import { useAuth } from "../../context/AuthContext";
import { fmtKg } from "./scConstants";
import DismissibleHelp from "../../components/DismissibleHelp";
import GxTable from "../../components/GxTable";

const { Option } = Select;

export default function WarehouseReceiptPage() {
  const { can } = useAuth();
  const [form] = Form.useForm();
  const [dyers, setDyers] = useState([]);
  const [recent, setRecent] = useState([]);
  const [loading, setLoading] = useState(false);

  const loadRecent = async () => {
    try {
      const r = await scGetEvents({ event_type: "dyed_fabric_received_in_gharchak_warehouse" });
      setRecent(r.data);
    } catch { /* silent */ }
  };
  useEffect(() => {
    scGetParties({ party_type: "dyeing_provider" }).then((r) => setDyers(r.data)).catch(() => {});
    loadRecent();
  }, []);

  const submit = async () => {
    const v = await form.validateFields();
    setLoading(true);
    try {
      await scWarehouseReceipt({ ...v, event_date: v.event_date || todayISO() });
      message.success("ورودِ انبار ثبت شد و موجودی انبار قرچک افزایش یافت");
      form.resetFields();
      form.setFieldsValue({ event_date: todayISO() });
      loadRecent();
    } catch (e) { message.error(e?.response?.data?.detail || "خطا در ثبت"); }
    setLoading(false);
  };

  const columns = [
    { title: "کد", dataIndex: "event_code", width: 150 },
    { title: "تاریخ", dataIndex: "event_date", width: 110, sorter: byDate("event_date"), render: (v) => toJalali(v) },
    { title: "از (رنگرز)", dataIndex: "source_party_name", width: 120 },
    { title: "نوع پارچه", dataIndex: "fabric_type", render: (v) => v || "—" },
    { title: "رنگ", dataIndex: "color", width: 90, render: (v) => v || "—" },
    { title: "وزن", dataIndex: "weight_kg", width: 120, align: "center", render: (v) => fmtKg(v) },
    { title: "وضعیت", dataIndex: "status", width: 100, render: () => <Tag color="green">ثبت‌شده</Tag> },
  ];

  return (
    <div>
      <h2 style={{ marginTop: 0 }}>ورود انبار قرچک (پارچهٔ رنگ‌شده)</h2>
      <DismissibleHelp id="sc-warehouse"
        message="ثبتِ پارچهٔ رنگ‌شده‌ای که از پوشان به انبار قرچک رسیده است. با ثبت، موجودیِ انبار قرچک افزایش می‌یابد. (در این فاز به تولید/مصرف وصل نمی‌شود.)" />
      <Space align="start" wrap size="large" style={{ width: "100%" }}>
        <Card title="ثبت رسید انبار" style={{ minWidth: 360 }}>
          {can("sc.event.create") ? (
            <Form form={form} layout="vertical" style={{ direction: "rtl" }}
              initialValues={{ event_date: todayISO() }}>
              <Form.Item name="source_party_id" label="رنگرز (مبدأ)" rules={[{ required: true, message: "رنگرز را انتخاب کنید" }]}>
                <Select showSearch optionFilterProp="children" placeholder="پوشان">
                  {dyers.map((d) => <Option key={d.id} value={d.id}>{d.name}</Option>)}
                </Select>
              </Form.Item>
              <Form.Item name="event_date" label="تاریخ ورود (خالی = امروز)" rules={[{ required: true }]}>
                <JalaliDateInput />
              </Form.Item>
              <Form.Item name="weight_kg" label="وزن (کیلوگرم)" rules={[{ required: true, message: "وزن لازم است" }]}>
                <InputNumber min={0.001} style={{ width: "100%" }} />
              </Form.Item>
              <Space wrap>
                <Form.Item name="fabric_type" label="نوع پارچه"><Input style={{ width: 150 }} /></Form.Item>
                <Form.Item name="color" label="رنگ"><Input style={{ width: 120 }} /></Form.Item>
              </Space>
              <Space wrap>
                <Form.Item name="roll_count" label="تعداد طاقه"><InputNumber min={0} style={{ width: 120 }} /></Form.Item>
                <Form.Item name="carton_count" label="کارتن"><InputNumber min={0} style={{ width: 110 }} /></Form.Item>
              </Space>
              <Form.Item name="notes" label="یادداشت"><Input.TextArea rows={2} /></Form.Item>
              <Button type="primary" icon={<InboxOutlined />} loading={loading} onClick={submit} block
                style={{ background: "#52c41a", borderColor: "#52c41a" }}>
                ثبت ورود به انبار
              </Button>
            </Form>
          ) : <div style={{ color: "#888" }}>برای ثبت رسید انبار دسترسی ندارید.</div>}
        </Card>

        <Card title="ورودهای اخیر انبار" style={{ flex: 1, minWidth: 420 }}>
          <GxTable dataSource={recent} columns={columns} rowKey="id" size="small"
            pagination={{ pageSize: 10 }} scroll={{ x: "max-content" }} />
        </Card>
      </Space>
    </div>
  );
}
